import * as React from "react"

import Home from "../components/Home/Home";
import Seo from "../components/SEO/Seo";
import Layout from "../components/Layout/Layout";


const IndexPage = () => {
  return (

      <Layout>
         <Home />
      </Layout>
  )
}

export default IndexPage

export const Head = () => (
    <>
        <Seo  description={'Get the keys to your crypto assets and earn passive income with our one of kind decentralized crypto wallet.'}
              title={'Changex: Buy, Own, and Earn Crypto'}
              imageAlt="Changexio Personal Finance"/>
    </>
)
